import React from 'react';
import { Typography } from '@mui/material';
import { WarningRounded as WarningRoundedIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Tooltip from '@src/components/Tooltip';
import { COLOR } from '@src/styles/color';
import sanitize from 'sanitize-html';

const CreditsCount = ({
  exceedBlockMaxCredits,
  credits,
  maxCredits,
  isAdvancedVoice,
  exceedBlockMaxCreditsDescription,
  creditFactor,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  return (
    <div className="char-count">
      {isAdvancedVoice && (
        <Tooltip
          arrow
          title={t('doubleCharPerBlock', {
            credits: (credits * creditFactor).toLocaleString(language),
            creditFactor,
          })}
          placement="left"
        >
          <Typography className="text double-char">
            {t('doubleChar', {
              creditFactor,
            })}
          </Typography>
        </Tooltip>
      )}
      {exceedBlockMaxCredits && (
        <Tooltip
          arrow
          title={
            <Typography
              component="span"
              sx={{ fontSize: '14px', textAlign: 'left' }}
              style={{ textAlign: 'left' }}
              dangerouslySetInnerHTML={{
                __html: sanitize(exceedBlockMaxCreditsDescription, {
                  allowedTags: ['br', 'p'],
                  allowedAttributes: {
                    p: ['style'],
                    br: ['style'],
                  },
                }),
              }}
            />
          }
          placement="left"
        >
          <div className="exceed-block-char-icon">
            <WarningRoundedIcon sx={{ color: COLOR.danger, fontSize: 20 }} />
          </div>
        </Tooltip>
      )}
      <div>
        <span
          className={`text current-char-count ${
            exceedBlockMaxCredits && 'exceed-block-max-char'
          }`}
        >
          {credits.toLocaleString(language)}
        </span>
        <span className="text total-char-count">
          /{maxCredits.toLocaleString(language)}
        </span>
      </div>
    </div>
  );
};

export default CreditsCount;
